import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import s from './Description.module.css';
import sg from '../../../../styles/index.module.css';
import { updateInventoryRequest } from '../../../store/slices/boardSlice';

export function Description({ description, inventoryGuid }) {
    const [descriptionText, setDescriptionText] = useState(description);
    const dispatch = useDispatch();
    const saveDescription = useCallback(() => {
        dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ description: descriptionText.trim() }),
                inventoryGuid,
            })
        );
        setDescriptionText(descriptionText.trim());
    }, [descriptionText, inventoryGuid]);

    return (
        <div className={s.description}>
            <h4 className={s.subTitle}>
                {i18next.t('Description.return.subTitle')}
            </h4>
            <textarea
                data-id="description-inventory-input"
                className={cx(sg.input, s.descriptionInput)}
                onChange={(e) => {
                    setDescriptionText(e.target.value);
                }}
                onBlur={() => {
                    saveDescription();
                }}
                maxLength="1000"
                value={descriptionText}
            />
        </div>
    );
}
